import PropTypes from 'prop-types';
import React, { Component } from 'react';

import UserTypeSelect from './user-type-select';
import UserCountrySelect from './user-country-select';
import PersonalInfo from './personal-info';
import Translator from '../../cornucopia/core/translator';

class CUForm extends React.Component {
  static propTypes = {
    userType: PropTypes.string,
    userCountry: PropTypes.string,
    requesterName: PropTypes.string,
    requesterEmail: PropTypes.string,
    subject: PropTypes.string,
    message: PropTypes.string,
    formStatus: PropTypes.string,
    onFieldChange: PropTypes.func,
    onUserTypeChange: PropTypes.func,
    onUserCountryChange: PropTypes.func,
    onSubmitForm: PropTypes.func
  };

  _shouldComponentRender = () => {
    return (
      this.props.userType === 'tenant' ||
      this.props.userType === 'landlord' ||
      this.props.formStatus === 'error'
    );
  };

  _renderForm = () => {
    if (this.props.formStatus === 'success') {
      return (
        <p className="contact-us__message contact-us__message--success">
          {Translator.trans('contact_us.personal_info.success')},<br />
          {Translator.trans('contact_us.personal_info.success.content')}
        </p>
      );
    }

    return (
      <form action="#" method="post">
        <UserTypeSelect
          userType={this.props.userType}
          onUserTypeChange={this.props.onUserTypeChange}
        />

        {this._shouldComponentRender() && (
          <UserCountrySelect
            userType={this.props.userType}
            userCountry={this.props.userCountry}
            onUserCountryChange={this.props.onUserCountryChange}
          />
        )}

        <PersonalInfo
          userType={this.props.userType}
          userCountry={this.props.userCountry}
          requesterName={this.props.requesterName}
          requesterEmail={this.props.requesterEmail}
          subject={this.props.subject}
          message={this.props.message}
          formStatus={this.props.formStatus}
          onFieldChange={this.props.onFieldChange}
          onSubmitForm={this.props.onSubmitForm}
        />
      </form>
    );
  };

  render() {
    return (
      <div className="grid__wrapper contact-us__main-content">
        <div className="grid__wrapper--inner">
          <div className="grid">
            <div className="grid__col grid__col--2-of-3 grid__col--centered">
              {this._renderForm()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CUForm;